import { render, staticRenderFns } from "./config_LotteryCommission.vue?vue&type=template&id=f5cf1c0e&scoped=true"
import script from "./config_LotteryCommission.vue?vue&type=script&lang=js"
export * from "./config_LotteryCommission.vue?vue&type=script&lang=js"
import style0 from "./config_LotteryCommission.vue?vue&type=style&index=0&id=f5cf1c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cf1c0e",
  null
  
)

export default component.exports